import { mainGet } from '../net/mainApi';

const toStudentsArray = (data) => {
    if (Array.isArray(data)) return data;
    if (data && typeof data === 'object') return Object.values(data);
    return [];
};

export const fetchStudentsByOwner = async (clid) => {
    const response = await mainGet({ type: 'getglobalstudents', id: clid });
    const allStudents = toStudentsArray(response.data);

    return {
        activeStudents: allStudents.filter(student => student?.archived === '0'),
        archivedStudents: allStudents.filter(student => student?.archived === '1')
    };
};

export const createStudentAccount = async (clid, formData) => {
    return mainGet({
        type: 'createuser',
        _r: `${window.location.origin}/defaulticon.png`,
        id: clid,
        name: formData.name,
        sname: formData.sname,
        ot: formData.ot || '',
        email: formData.email || '',
        phone: formData.phone || '',
        sphone: formData.sphone || '',
        city: formData.city || '',
        place: formData.cityW || '',
        by: formData.char || '',
        bday: formData.bday || '',
        about: formData.about || '',
        role: 'student'
    });
};

export const deleteStudentAccount = async (clid, studentId) => {
    return mainGet({ type: 'deleteAccount', id: clid, delId: studentId });
};

export const archiveStudentAccount = async (clid, key, studentId) => {
    return mainGet({
        type: 'archiveStudent',
        uid: clid,
        key,
        student: studentId
    });
};

export const unarchiveStudentAccount = async (clid, key, studentId) => {
    return mainGet({
        type: 'unarchiveStudent',
        uid: clid,
        key,
        student: studentId
    });
};

export const changeStudentPassword = async (clid, key, studentId, hashedPassword) => {
    return mainGet({
        type: 'changeStudentPassword',
        uid: clid,
        key,
        student: studentId,
        newPass: hashedPassword
    });
};
